import { render, staticRenderFns } from "./submitDateChangeEdit.vue?vue&type=template&id=6fcdb910&scoped=true&"
import script from "./submitDateChangeEdit.vue?vue&type=script&lang=ts&"
export * from "./submitDateChangeEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcdb910",
  null
  
)

export default component.exports